import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType,HttpHeaders } from '@angular/common/http';
import { TokenService } from '../../token.service';
import { MainService } from './main.service';
@Injectable({
  providedIn: 'root'
})
export class EbillService {


  httpUrl;
  constructor(private http: HttpClient, private main: MainService, private token:TokenService) {

    this.httpUrl = this.main.httpUrl ;
  }
  // async getPartRate(obj:any){
  //   const resp = await this.http.get<any>(this.main.httpUrl + '/info/ebill/getPartRateData' + obj   ).toPromise().then(res => {
  //     return res;
  //   });
  //   return resp;

  // }
  async getApprBill(obj:any ) {
    const resp = await this.http.get<any>(this.main.httpUrl2 + '/operation/bill/getBill' + obj   ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async getbillmasterdeduction(acct_id:any ){
    const resp= this.http.get<any>(this.main.httpUrl2 + '/operation/info/masterdeduction/getmasterdeduction'+acct_id ).toPromise().then(res =>{
      return res
    });
    return resp
  }
  async getbillALLDed(obj:any ) {
    const resp = await this.http.get<any>(this.main.httpUrl2 + '/operation/info/ebill/billgetdeduction' + obj   ).toPromise().then(res => {
      return res;
    });
    return resp;

  }

  async getApprAmcBill(obj:any) {
    const resp = await this.http.get<any>(this.main.httpUrl2 + '/operation/bill/AMCApprBill' + obj   ).toPromise().then(res => {
      return res;
    });
    return resp;
  }

 async  getPaymentSchedule(obj:any){
  console.log(obj)
    const resp = await this.http.get<any>(this.main.httpUrl + '/info/ebill/getPaymentSchedule' + obj   ).toPromise().then(res => {
          return res;
        });
        return resp;
  }

  async getquantityofprevbill(obj:any){
    const resp = await this.http.get<any>(this.main.httpUrl + '/info/ebill/getquantityofprevbill' + obj   ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async getmasterdeduction(acct_id:any){
    const resp= this.http.get<any>(this.main.httpUrl + '/info/masterdeduction/getmasterdeduction'+acct_id ).toPromise().then(res =>{
      return res
    });
    return resp
  }

  async getLastPaymentAndDeduction(obj:any){
    const resp= this.http.get<any>(this.main.httpUrl + '/info/boq/getLastPaymentAndDeduction'+obj ).toPromise().then(res =>{
      return res
    });
    return resp
  }
  async updateLastPaymentAndDeduction(obj:any){
    const resp = await this.http.put<any>(this.main.httpUrl + '/info/boq/updateLastPaymentAndDeduction' , obj   ).toPromise().then(res => {
      return res;
    });
    return resp;

  }

  async getlastbillrate(obj:any){
    const resp = await this.http.get<any>(this.main.httpUrl + '/info/ebill/getlastbillrate' + obj   ).toPromise().then(res => {
      return res;
    });
    return resp;

  }
  async getdevemb(obj:any){
    const resp = await this.http.get<any>(this.main.httpUrl + '/info/ebill/getdevemb' + obj   ).toPromise().then(res => {
      return res;
    });
    return resp;

  }

  async getPrevRate(obj:any){
    const resp = await this.http.get<any>(this.main.httpUrl + '/info/ebill/getPrevRate' + obj   ).toPromise().then(res => {
      return res;
    });
    return resp;

  }


  async deletePrevRate(obj:any){
    const resp = await this.http.delete<any>(this.main.httpUrl + '/info/ebill/deletePrevRate' + obj   ).toPromise().then(res => {
      return res;
    });
    return resp;

  }
  async insertPrevRate(obj:any){
    const resp = await this.http.post<any>(this.main.httpUrl + '/info/ebill/insertPrevRate' , obj   ).toPromise().then(res => {
      return res;
    });
    return resp;

  }
  async updatePrevRate(obj:any){
    const resp = await this.http.put<any>(this.main.httpUrl + '/info/ebill/updatePrevRate' , obj   ).toPromise().then(res => {
      return res;
    });
    return resp;

  }
  async getBoq(obj:any){
    const resp = await this.http.get<any>(this.main.httpUrl + '/info/boq/getBoq' + obj   ).toPromise().then(res => {
      return res;
    });
    return resp;

  }
  async getBill(obj:any){
    const resp = await this.http.get<any>(this.main.httpUrl + '/info/ebill/getbill' + obj   ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async systemDate() {
    const resp = await this.http.get<any>(this.main.httpUrl + '/systemData/getsystemdate' ).toPromise().then(res => {
      return res;
    });
    return resp;

  }
  async updateebillStatus(obj:any){
    const resp = await this.http.put<any>(this.main.httpUrl + '/info/ebill/updateebillstatus' , obj   ).toPromise().then(res => {
      return res;
    });
    return resp;

  }
  async updatededuction(obj:any){
    const resp = await this.http.post<any>(this.main.httpUrl + '/info/ebill/updatededuction' , obj   ).toPromise().then(res => {
      return res;
    });
    return resp;

  }
  async getHeadRecord(obj:any){
    const resp= this.http.get<any>(this.main.httpUrl+'/info/head/getheadDetails'+obj ).toPromise().then(res =>{
      return res
    });
    return resp
  }
  async updateDeduction(obj:any){
    const resp = await this.http.put<any>(this.main.httpUrl + '/info/ebill/updateDeduction' , obj   ).toPromise().then(res => {
      return res;
    });
    return resp;

  }
  async getded(obj:any){
    const resp = await this.http.get<any>(this.main.httpUrl + '/info/deduction/getded' + obj   ).toPromise().then(res => {
      return res;
    });
    return resp;

  }
  async getALLDed(obj:any){
    const resp = await this.http.get<any>(this.main.httpUrl + '/info/ebill/getdeduction' + obj   ).toPromise().then(res => {
      return res;
    });
    return resp;

  }

  async getBillsOfWork(obj:any){
    const resp = await this.http.get<any>(this.main.httpUrl + '/info/ebill/getebill' + obj   ).toPromise().then(res => {
      return res;
    });
    return resp;

  }
  async getLastBill(obj:any){
    const resp = await this.http.get<any>(this.main.httpUrl + '/info/ebill/getLastBill' + obj   ).toPromise().then(res => {
      return res;
    });
    return resp;

  }
  async getgenemb(obj:any){
    const resp = await this.http.get<any>(this.main.httpUrl + '/info/emb/getgenemb' + obj   ).toPromise().then(res => {
      return res;
    });
    return resp;

  }
  async getPartRate(obj:any){
    const resp = await this.http.get<any>(this.main.httpUrl + '/info/ebill/getPartRateData' + obj   ).toPromise().then(res => {
      return res;
    });
    return resp;

  }
  async deleteebill(obj:any){
    const resp = await this.http.delete<any>(this.main.httpUrl + '/info/ebill/deleteebill' + obj   ).toPromise().then(res => {
      return res;
    });
    return resp;

  }
  async updateebill(obj:any){
    const resp = await this.http.put<any>(this.main.httpUrl + '/info/ebill/updateebill' , obj   ).toPromise().then(res => {
      return res;
    });
    return resp;

  }

  async createebill(obj:any){
    const resp = await this.http.post<any>(this.main.httpUrl + '/info/ebill/createebill' , obj   ).toPromise().then(res => {
      return res;
    });
    return resp;

  } async updateGlobalBillID(obj:any){
    const resp = await this.http.put<any>(this.main.httpUrl + '/info/ebill/updateGlobalBillNo', obj   ).toPromise().then(res => {
      return res;
    });
    return resp;

  }
  async addactivity(obj:any){
    const resp = await this.http.put<any>(this.main.httpUrl + '/info/work/addactivity', obj   ).toPromise().then(res => {
      return res;
    });
    return resp;

  }

  async getWorkBudInfo(obj:any){
    const resp = await this.http.get<any>(this.main.httpUrl + '/info/ebill/getWorkBudInfo'+ obj   ).toPromise().then(res => {
      return res;
    });
    return resp;

  }
  async sendEbillToAccount(obj:any){
    const resp = await this.http.post<any>('http://180.233.122.171:8080/ICICI/models' , obj   ).toPromise().then(res => {
      return res;
    });
    return resp;
  }


}
